import { useLazyQuery } from '@apollo/client';
import React, { useState } from 'react';

import { Logo } from './CryoFuture.styled';
import {
  ButtonsContainer,
  IconContainer,
  IllustratedBackgroundWidget,
  TextRow,
  WidgetTitleContainer
} from '../Widgets/Widgets.styled';
import cryoLogo from 'assets/images/cryo.webp';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import KBContacts from 'kb-shared/utilities/kindbody_contacts';
import { showErrorToast } from 'utilities/notificationUtils';

import { CRYO_FUTURE_REGISTRATION_LINK } from '../Dashboard.graphql';
import { CryoFutureRegistrationLinkResponse } from '../Dashboard.types';

export const CryoFuture = () => {
  const [isLoading, setIsLoading] = useState(false);

  const [getCryoFutureLink] = useLazyQuery<CryoFutureRegistrationLinkResponse>(
    CRYO_FUTURE_REGISTRATION_LINK,
    {
      onCompleted: data => {
        setIsLoading(false);
        if (data?.cryoFutureRegistrationLink) {
          window.open(data.cryoFutureRegistrationLink, '_blank');
        } else {
          showErrorMessage();
        }
      },
      onError: () => {
        setIsLoading(false);
        showErrorMessage();
      }
    }
  );

  const showErrorMessage = () =>
    showErrorToast(
      `Registration attempt failed. Please try again or contact us at ${KBContacts.navigatorEmail}`
    );

  const handleRegisterClick = () => {
    setIsLoading(true);
    getCryoFutureLink();
  };
  return (
    <IllustratedBackgroundWidget variant={0}>
      <IconContainer $height={72}>
        <Logo src={cryoLogo} alt="CryoFuture logo" height={48} />
      </IconContainer>
      <WidgetTitleContainer>
        <Heading tag="div" styledAs="h2">
          CryoFuture
        </Heading>
      </WidgetTitleContainer>
      <TextRow>
        <Text fontStyle="semibold">
          CryoFuture is Kindbody's preferred partner for secure, long-term storage and
          transportation of your precious reproductive specimens.
        </Text>
      </TextRow>
      <TextRow>
        <Text fontStyle="regular">
          As a trusted leader in cryogenic storage across the U.S., CryoFuture is commited to
          safeguarding your embryos, oocytes, and sperm with the highest standards of safety and
          care.
        </Text>
      </TextRow>

      <ButtonsContainer>
        <Button
          category="primary-dark"
          onClick={handleRegisterClick}
          label="Register Now"
          size="lg"
          isDisabled={isLoading}
        />
      </ButtonsContainer>
    </IllustratedBackgroundWidget>
  );
};
